export const color = `
  id
  handle
  label: field(key: "label") {
    value
  }
  color: field(key: "color") {
    value
  }
  image: field(key: "image") {
    reference {
      ... on MediaImage {
        alt
        previewImage {
          url
        }
      }
    }
  }
`;

const badge = `
  badge: metafield(namespace: "content", key: "product_badge") {
    reference {
      ... on Metaobject {
        text: field(key: "text") {
          value
        }
        color: field(key: "color") {
          value
        }
        showInCart: field(key: "show_in_cart") {
          value
        }
      }
    }
  }
`;

export const product = `
  id
  title
  handle
  onlineStoreUrl
  priceRange {
    minVariantPrice {
      amount
      currencyCode
    }
  }
  compareAtPriceRange {
    minVariantPrice {
      amount
      currencyCode
    }
  }
  featuredImage {
    altText
    url
  }
  options {
    name
    optionValues {
      name
      swatch {
        image {
          alt
          previewImage {
            url
          }
        }
        color
      }
    }
  }
  variants(first: 250) {
    edges {
      node {
        id
        title
        availableForSale
        quantityAvailable
        price {
          amount
          currencyCode
        }
        compareAtPrice {
          amount
          currencyCode
        }
        selectedOptions {
          name
          value
        }
        image {
          altText
          url
        }
        components: metafield(namespace: "details", key: "components") {
          references(first: 100) {
            edges {
              node {
                ... on ProductVariant {
                  id
                  sku
                  title
                  quantityAvailable
                  product {
                    title
                  }
                }
              }
            }
          }
        }
        multiComponents: metafield(namespace: "details", key: "multi_components") {
          references(first: 100) {
            edges {
              node {
                ... on Metaobject {
                  variant: field(key: "variant") {
                    reference {
                      ... on ProductVariant {
                        id
                        sku
                        title
                        quantityAvailable
                        product {
                          title
                        }
                      }
                    }
                  }
                  quantity: field(key: "quantity") {
                    value
                  }
                }
              }
            }
          }
        }
        ${badge}
        cargoReady: metafield(namespace: "details", key: "cargo_ready") {
          value
        }
        dnr: metafield(namespace: "details", key: "dnr") {
          value
        }
        backorderDate: metafield(namespace: "details", key: "backorder_date") {
          value
        }
        lowStockThreshold: metafield(namespace: "details", key: "low_stock_threshold") {
          value
        }
        retailPrice: metafield(namespace: "details", key: "retail_price") {
          value
        }
        materialGroup: metafield(namespace: "configurability", key: "material_group") {
          value
        }
        auStockMessage: metafield(namespace: "content", key: "stock_message") {
          value
        }
        hideOnPdp: metafield(namespace: "content", key: "hide_on_pdp") {
          value
        }
        maxQuantityThreshold: metafield(namespace: "details", key: "max_quantity_threshold") {
          value
        }
      }
    }
  }
  materialGroup: metafield(namespace: "configurability", key: "material_group") {
    value
  }
  colors: metafield(namespace: "shopify", key: "color-pattern") {
    references(first: 100) {
      nodes {
        ... on Metaobject {
          id
          handle
        }
      }
    }
  }
  bundleColor: metafield(namespace: "details", key: "bundle_color") {
    reference {
      ... on Metaobject {
        ${color}
      }
    }
  }
  bundleColorLabel: metafield(namespace: "details", key: "bundle_color_label") {
    value
  }
  discontinuedRedirect: metafield(namespace: "content", key: "discontinued_redirect") {
    reference {
      ... on Product {
        onlineStoreUrl
        handle
      }
    }
  }
  ${badge}
`;

export const productGroup = `
    group: metafield(namespace: "details", key: "group") {
      reference {
        ... on Metaobject {
          id
          handle
          products: field(key: "products") {
            references(first: 100) {
						  nodes {
                ... on Product {
                  ${product}
                }
              }
            }
          }
          bundleColors: field(key: "bundle_colors") {
            references(first: 100) {
              nodes {
                ... on Metaobject {
                  ${color}
                }
              }
            }
          }
        }
      }
    }
`;

export const cart = `
  id
  delivery {
    addresses {
      id
      selected
      oneTimeUse
      address {
        ... on CartDeliveryAddress {
          firstName
          lastName
          company
          address1
          address2
          city
          provinceCode
          zip
          countryCode
        }
      }
    }
  }
`;
